var validateIndex = function validateIndex(index, options) {
  if (index < 0) return 0;
  if (index >= options.length) return options.length - 1;
  return index;
};
var getOptionIndex = function getOptionIndex(options, selectedOption) {
  var valueProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  var index = options.findIndex(function (option) {
    return option[valueProperty] === selectedOption;
  });
  return validateIndex(index, options);
};
var isAM = function isAM(time) {
  return time && time.hour() < 12;
};
var convertTimeString = function convertTimeString(string) {
  if (!string) return null;
  var meridiem = 'AM';
  if (string.toUpperCase().includes('PM')) meridiem = 'PM';
  var arr = string.split(':');
  var hour = parseInt(arr[0], 10);
  if (meridiem === 'PM' && hour !== 12) hour += 12; // formats to 24

  if (meridiem === 'AM' && hour === 12) hour = 0;
  if (meridiem === 'PM' && hour === 12) hour = 12;
  var min = parseInt(arr[1], 10);
  var sec = parseInt(arr[2], 10);
  return {
    hour: hour,
    min: min,
    sec: sec
  };
};

export { convertTimeString, getOptionIndex, isAM, validateIndex };
//# sourceMappingURL=utils.js.map
